<template>
  <div class="onepager-container offerte">
    <onepager
      v-if="onepager"
      :environment="environment"
      :logo="logo"
      :multiRowPath="onepager.multiRowPath"
      :products="onepager.products"
      :tableConfig="onepager.tableConfig"
      :template="getTemplateManager(onepager.template)"
    ></onepager>
  </div>
</template>

<script>
import Onepager from '../onepager/Onepager'
import ProductService from "../../service/ProductService"
import ConfigService from "../../service/ConfigService"
import {EventBus,} from "../../service/EventBus"
import TemplateManager from '../../service/TemplateManager'
import TokenService from "../../service/TokenService"
import DocumentContainer from "../document/DocumentContainer"

export default {
  name: 'product-list',

  // vue-head is used to set & update the css
  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: `/config/${this.environment}/style/onepager.css`,
        },
      ]
    },
  },

  components: {
    DocumentContainer,
    Onepager,
  },

  data: function () {
    return {
      products: [],
      onepager: null,
      pageCounter: 0,
      token: null,
    }
  },

  props: {
    environment: {
      type: String,
      required: true,
    },
    productIds: {
      type: String,
      required: true,
    },
    appInstance: {
      type: String,
      required: false,
    },
  },

  methods: {
    getTemplateManager(template) {
      return new TemplateManager(template)
    },
    fetchProducts() {
      ProductService.getProductsFromBroker(
        this.environment,
        this.appInstance,
        this.productIds.split('+'),
        this.token,
        'PRODUCT_LIST',
      ).then(result => {
          console.log(result.data.data[0])
          let products = result.data.data[0].onepagers[0]

          ConfigService.getDocumentConfig(
            'dericon',
            'product_list',
            'default',
            'default',
          ).then(documentConfig => {

            this.onepager = {
              template: documentConfig.data,
              products: products.products,
              tableConfig: products.columns,
              multiRowPath: products.pathToMultiRowCount,
            }
          })
        },
      )
    },
  },

  computed: {
    logo() {
      return ['config', this.environment, 'images', 'logo.png'].join('/')
    },
  },

  async created() {
    if (!this.$route.query.token) {
      this.token = await TokenService.checkToken()
    } else {
      this.token = this.$route.query.token
    }
    this.fetchProducts()
  },

  mounted() {
    EventBus.$on('pageCounter', amount => {
      this.pageCounter += amount
    })
  },

  watch: {
    // changes in the url are applied instantaneously
    environment() {
      this.$emit('updateHead')
    },
    productIds() {
      this.onepagers = []
      this.fetchProducts()
    },
    // token() {
    //   this.fetchProducts()
    // }
  },
}
</script>



// WEBPACK FOOTER //
// ProductList.vue?7d75842c